import Dexie from 'dexie';
import { uuidv4 } from './utils';
import * as contentTypes from './contentTypes'
import { func } from 'prop-types';
export const db = new Dexie('CMS');

db.version(3).stores({
    slides: '&id,type,lessonId', // Primary key and indexed props
    blobs: '[slideId+id]',
    lessons: '&id'
});

export async function addSlide({ id, name, type, lessonId, data }) {
    try {
        if (data) {
            data = await fixDataBlobs({ ...data }, id, type)
        }
        await db.slides.put({
            id, name, type, lessonId, data
        })
        return true;
    }
    catch (e) {
        console.error(e)
        return false;
    }
}

const addBlob = async (loclaBlobUrl, slideId) => {
    let fileId = uuidv4();
    let blob = await fetch(loclaBlobUrl).then(r => r.blob());
    await db.blobs.add({
        slideId: slideId,
        id: fileId,
        blob: blob
    })
    return fileId;
}

const fixDataBlobs = async (data, slideId, slideType) => {

    const replaceAndSaveSrcsInHTMLText = async (html) => {
        const doc = document.implementation.createHTMLDocument("New Document");
        doc.body.innerHTML = html;
        const imgs = doc.getElementsByTagName("img");
        for (let index = 0; index < imgs.length; index++) {
            const img = imgs[index];
            const newUrl = await addBlob(img.src, slideId);
            if (newUrl)
                img.src = `${newUrl}`
        }

        const videos = doc.getElementsByTagName("video");
        for (let index = 0; index < videos.length; index++) {
            const video = videos[index];
            const videoSource = video.getElementsByTagName("source")[0]
            const newUrl = await addBlob(videoSource.src, slideId);
            if (newUrl)
                videoSource.src = `${newUrl}`
        }

        const bgImages = doc.querySelectorAll("span[data-background],body[data-background]");

        for (let index = 0; index < bgImages.length; index++) {
            const bgImage = bgImages[index];
            const url = bgImage.getAttribute('data-background-url')
            const newUrl = await addBlob(url, slideId);
            if (newUrl) {
                bgImage.style.backgroundImage = `url(${newUrl})`
                bgImage.setAttribute('data-background-url', `${newUrl}`)

            }
        }
        return doc.body.innerHTML;
    }

    await db.blobs.where({ slideId: slideId }).delete();

    switch (slideType) {
        case contentTypes.file:
            let fileId = await addBlob(data.url, slideId);
            data.url = fileId;
            break;
        case contentTypes.image:
            let imageId = await addBlob(data.url, slideId);
            data.url = imageId;
            break;
        case contentTypes.tinyMCE:
            if (data.bgImage && data.bgImage.url) {
                const bgImageId = await addBlob(data.bgImage.url, slideId)
                data.bgImage = { ...data.bgImage, url: bgImageId }
            }
            const fileContent = data.html ? await replaceAndSaveSrcsInHTMLText(data.html) : "";
            data.html = fileContent;
            break;
        case contentTypes.quetion:
            if (data.bgImage && data.bgImage.url) {
                const bgImageQId = await addBlob(data.bgImage.url, slideId)
                data.bgImage = { ...data.bgImage, url: bgImageQId }
            }
            const quetions = [...data.quetions]
            for (let index = 0; index < quetions.length; index++) {
                const quetion = { ...quetions[index] };
                quetion.name = await replaceAndSaveSrcsInHTMLText(quetion.name);
                switch (quetion.type) {
                    case "options":
                        let options = [...quetion.data.options]
                        for (let optIndex = 0; optIndex < options.length; optIndex++) {
                            const opt = { ...options[optIndex] };
                            opt.content = await replaceAndSaveSrcsInHTMLText(opt.content)
                            options[optIndex] = opt;
                        }
                        quetion.data = { ...quetion.data, options: options };
                        break;
                    default:
                        break;
                }
                quetions[index] = quetion
            }
            data.quetions = quetions
        default:
            break;
    }
    return data;
}

export async function updateSlide(id, changes) {
    try {
        if (changes.data) {
            let data = await fixDataBlobs({ ...changes.data }, id, changes.type);
            changes.data = data;
        }
        await db.slides.update(id, changes);
        return true;
    }
    catch (e) {
        console.error(e)
        return false;
    }
}

export async function deleteSlide(id) {
    try {
        await db.blobs.where({ slideId: id }).delete();
        await db.slides.delete(id);
        return true;
    }
    catch (e) {
        console.error(e)
        return false;
    }
}

export async function updateOrder(lessonId, slides) {
    try {
        await db.lessons.put({ id: lessonId, order: slides });
        return true;
    }
    catch (e) {
        console.error(e)
        return false;
    }
}

export async function addPdfSlides(list, pdfSlideId, url) {
    try {
        const pdfSlide = await db.slides.get(pdfSlideId);
        const virtualSlideId = uuidv4()
        await addSlide({ id: virtualSlideId, lessonId: pdfSlide.lessonId, type: "pdfPages" })
        const urlId = await addBlob(url, virtualSlideId);
        const newSlides = list.map(s => ({ ...s, lessonId: pdfSlide.lessonId, data: { ...s.data, url: urlId } }))
        await db.slides.update(pdfSlideId, {
            data: {
                type: "pdf",
                url: urlId
            }
        })
        await db.slides.bulkAdd(newSlides);
        return true;
    }
    catch (e) {
        console.error(e)
        return false;
    }
}

export async function generateStateFromDB(lessonId) {

    const pdfs = {};
    const lesson = await db.lessons.get(lessonId);
    let slides = await db.slides.where({ lessonId: lessonId }).toArray();

    slides = await Promise.all(slides.map(async (slide) => {
        let blobs = await db.blobs.where({ slideId: slide.id }).toArray();
        return { ...slide, blobs: blobs };
    }))

    const pdfTempSlides = slides.filter(s => s.type === "pdfPages");
    const pdfBlobTempSlides = pdfTempSlides.reduce((arr, s) => {
        return arr.concat(s.blobs);
    }, [])

    slides = slides.filter(s => s.type !== "pdfPages");

    const createBlobfromId = async (id, blobsSlide) => {
        const blobTr = await blobsSlide.find(b => b.id === id);
        if (blobTr) {
            const blobUrl = URL.createObjectURL(blobTr.blob);
            return blobUrl;
        }
    }

    const replaceWithBlobsSrcsInHTMLText = async (html, blobsSlide) => {
        const doc = document.implementation.createHTMLDocument("New Document");

        doc.body.innerHTML = html;
        const imgs = doc.getElementsByTagName("img");
        for (let index = 0; index < imgs.length; index++) {
            const img = imgs[index];
            const imgSrc = img.src?.split("/").pop()
            const newUrl = await createBlobfromId(imgSrc, blobsSlide);
            img.src = newUrl;
        }

        const videos = doc.getElementsByTagName("video");
        for (let index = 0; index < videos.length; index++) {
            const video = videos[index];
            const videoSource = video.getElementsByTagName("source")[0]
            const videoSrc = videoSource.src?.split("/").pop()
            const newUrl = await createBlobfromId(videoSrc, blobsSlide);
            videoSource.src = newUrl;
        }

        const bgImages = doc.querySelectorAll("span[data-background]");

        for (let index = 0; index < bgImages.length; index++) {
            const bgImage = bgImages[index];
            // const url = bgImage.style.backgroundImage.slice(4, -1).replace(/"/g, "");
            const url = bgImage.getAttribute('data-background-url')
            const newUrl = await createBlobfromId(url, blobsSlide);
            bgImage.style.backgroundImage = `url(${newUrl})`;
            bgImage.setAttribute('data-background-url', newUrl)
        }

        return doc.body.innerHTML;
    }

    for (let i = 0; i < slides.length; i++) {
        const content = slides[i];
        const blobsSlide = content.blobs;
        if (content.data) {
            switch (content.type) {
                case contentTypes.tinyMCE:
                    const fileContentText = content.data.html;
                    const fileContentTextBlobs = await replaceWithBlobsSrcsInHTMLText(fileContentText, blobsSlide);
                    content.data.html = fileContentTextBlobs
                    if (content.data.bgImage && content.data.bgImage.url) {
                        const bgImageBlobUrl = await createBlobfromId(content.data.bgImage.url, blobsSlide);
                        content.data.bgImage.url = bgImageBlobUrl;
                    }
                    break;
                case contentTypes.file:
                    let tempUrl;
                    if (pdfs[content.data.url]) {
                        tempUrl = pdfs[content.data.url]
                    }
                    else {
                        tempUrl = await createBlobfromId(content.data.url, [...blobsSlide, ...pdfBlobTempSlides])
                        pdfs[content.data.url] = tempUrl;
                    }
                    content.data.url = tempUrl
                    break;
                case contentTypes.quetion:
                    if (content.data.bgImage && content.data.bgImage.url) {
                        const bgImageBlobUrl = await createBlobfromId(content.data.bgImage.url, blobsSlide);
                        content.data.bgImage.url = bgImageBlobUrl;
                    }
                    for (let index = 0; index < content.data.quetions.length; index++) {
                        const quetion = content.data.quetions[index];
                        const name = await replaceWithBlobsSrcsInHTMLText(quetion.name, blobsSlide);
                        quetion.name = name;
                        switch (quetion.type) {
                            case "options":
                                for (let optIndex = 0; optIndex < quetion.data.options.length; optIndex++) {
                                    const opt = quetion.data.options[optIndex];
                                    opt.content = await replaceWithBlobsSrcsInHTMLText(opt.content, blobsSlide)
                                }
                                break;
                            default:
                                break;
                        }
                    }
                    break;
                case contentTypes.image:
                    const imageTempUrl = await createBlobfromId(content.data.url, blobsSlide)
                    content.data.url = imageTempUrl
                    break;
                default:
                    break;
            }
        }
    }

    const slidesByOrder = lesson.order.map(id => slides.find(s => s.id === id)).filter(s => s);
    const slidesWithoutOrder = slides.filter(s => !lesson.order.includes(s.id));

    return slidesByOrder.concat(slidesWithoutOrder);
}

export async function deleteLesson(lessonId) {
    await db.lessons.delete(lessonId);
    const slides = await db.slides.where({ lessonId: lessonId });
    const slidesArr = await slides.toArray();
    await Promise.all(slidesArr.map(async slide => await db.blobs.where({ slideId: slide.id }).delete()));
    await slides.delete();
}
export async function deleteLessonWithoutSlide(lessonId) {
    await db.lessons.delete(lessonId);
}

export async function lessonExist(lessonId) {
    return await db.lessons.get(lessonId);
}